import { FundingComputedDto } from '@src/data/types/FundingComputedDto'
import { FundingInfoDto } from '@src/data/types/FundingInfoDto'
import {
  EditIfXpressWorksheetDto,
  IfXpressWorksheet,
  IfXpressWorksheetRevision,
} from '@src/data/types/IfXpressWorksheetSchema'
import { WorksheetDecision } from '../../types'
import { makeCreate, makeGetListWithIdsFromApi, makeGetSingleFromApi, makeUpdate } from '../make-api'

const baseUrl = '/Applications/ifxpress/{creditApplicationId}/Worksheet'
const ifXpressWorksheetApi = {
  getById: makeGetSingleFromApi<IfXpressWorksheet>(baseUrl),
  create: makeCreate<EditIfXpressWorksheetDto, IfXpressWorksheet>(baseUrl),
  update: makeUpdate<EditIfXpressWorksheetDto, IfXpressWorksheet>(baseUrl),
  computeIfXpressFunding: makeCreate<FundingInfoDto, FundingComputedDto>('Applications/ComputeFunding'),
  getWorksheetRevisions: makeGetListWithIdsFromApi<IfXpressWorksheetRevision>(`${baseUrl}/Revisions`),
  updateDecision: makeUpdate<WorksheetDecision, IfXpressWorksheet>(`${baseUrl}/Decision`),
}
export default ifXpressWorksheetApi
